import { usePagination } from 'react-instantsearch';

export const VirtualPagination: React.FC = () => {
    usePagination();

    return null;
};
